import * as React from "react";
import { DeviceData } from "../models/DeviceData";
import Modal from "react-bootstrap/Modal";
import { DeviceMenuProps } from "../models/deviceMenuProps";

interface Props {
    closeModal: () => void;
    deviceBarDeviceMenuProps: DeviceMenuProps;
}

const DeviceBarDeviceMenuItems = (props: Props) => {
    const menuProps = props.deviceBarDeviceMenuProps;

    return (
        <Modal
            show={true}
            size="sm"
            animation={false}
            onEscapeKeyDown={() => props.closeModal()}
            onHide={() => props.closeModal()}
        >
            <div className="device_menuItems" style={{ position: "fixed", display: 'block', top: `${menuProps.top}px`, left: `${menuProps.left}px` }}>
                {props.deviceBarDeviceMenuProps.actions &&
                    props.deviceBarDeviceMenuProps.actions.map((action, i) => {
                        return (
                            <div key={i} onClick={() => action.do()}>
                                <span>{action.name}</span>
                            </div>
                        )
                    })}
            </div>
        </Modal>
    );
}

export default DeviceBarDeviceMenuItems;